<template>
  <component v-if="detailComponentName" :is="detailComponentName" />
</template>

<script>
import { getCourseViewer } from 'views/Course/utils/viewer';

/**
 * @module CheckInDetailEntry 课次签到详情分发壳（Teacher / Admin）
 */
export default {
  name: 'CheckInDetailEntry',
  components: {
    TeacherDetail: () => import('./Teacher'),
    AdminDetail: () => import('./Admin')
  },
  data: () => ({
    viewer: ''
  }),
  computed: {
    detailComponentName() {
      if (this.viewer === 'teacher') return 'TeacherDetail';
      if (this.viewer === 'admin') return 'AdminDetail';
      return '';
    }
  },
  async created() {
    this.viewer = await getCourseViewer(this);
    if (this.detailComponentName) {
      return;
    }
    this.$router.replace({ name: 'dashboard' });
  }
};
</script>
